<script lang="ts" setup>
import {
  computed,
  h,
  onMounted,
  reactive,
  ref,
  useRoute,
  useRouter,
  watchEffect,
} from '#imports';
import { createVNode, render } from 'vue';
import { notification } from 'ant-design-vue';
import { useService } from '@kaokei/use-vue-service';
import ActivityModal from '~/components/ActivityModal/ActivityModal.vue';
import { useAuthReward } from '~/composables/use-auth-reward';
import { UserService } from '~/services/user.service';
import type { RewardVo } from '~/types/auto/heartbeat';
import { EXCLUDE_PAGES } from '~/utils/constant';
import { uuid } from '~/utils/uuid';

const REWARD_TYPE = {
  DRAGON_BOAT: 100,
};
const router = useRouter();
const route = useRoute();
const userService = useService(UserService);
const active = computed(() => {
  const inactiveConditions = [
    !userService.isLogin(),
    EXCLUDE_PAGES.includes(route.name as string),
    userService.bindphoneService.visible,
    userService.profileService.visible,
    userService.profileService.programLevelVisible,
    !(userService.user.nickname)
  ];
  return !inactiveConditions.some(Boolean);
});

const { data: rewardList, loading: isLoadingRewardList } = useAuthReward(
  active,
  300,
);

const activityModalParams = reactive({
  teamId: 0,
  visible: false,
});

const getNotificationParams = (reward: RewardVo) => {
  const key = uuid();
  const data: any = {
    key,
    message: '通过奖励：' + reward.rewardName,
  };
  if (reward.rewardImage) {
    data.icon = () => h('img', { src: reward.rewardImage });
  }
  switch (reward.rewardType) {
    case 0:
      //谷子券
      data.message += `*${reward.count}`;
      data.description = '可在首页抽谷子获取奖励';
      data.onClick = () => {
        notification.close(key);
        router.push('/');
      };
      break;
    case 5:
      //徽章
      data.description = '可在个人中心-我的谷子中查看';
      break;
  }
  if (reward.rewardType === 0 && reward.count === 0) {
    // 与后端的特殊约定count为0代表已经满了
    data.message = `抽谷机会已满，快去使用吧`;
  }
  return data;
};
function showActivityModal(teamId: number) {
  activityModalParams.teamId = teamId;
  activityModalParams.visible = true;
}
watchEffect(() => {
  if (rewardList.value?.length) {
    rewardList.value.forEach((reward: RewardVo) => {
      const args = getNotificationParams(reward);
      switch (reward.rewardType) {
        case REWARD_TYPE.DRAGON_BOAT:
          showActivityModal(reward.rewardId as number);
          break;
        default:
          notification.open({
            class: 'ht-notification',
            duration: 5,
            ...args,
          });
          break;
      }
    });
  }
});
</script>
<template>
  <ActivityModal
    v-model:open="activityModalParams.visible"
    :team-id="activityModalParams.teamId"
  />
</template>
<style>
.ht-notification {
  padding: 20px 20px 22px;
  background-color: #fff;
  border: 1px solid rgba(229, 230, 235, 1);
  box-shadow: 0px 4px 10px 0px rgba(0, 0, 0, 0.1);
}
.ht-notification .ant-notification-notice-with-icon {
  display: grid;
  grid-template-columns: 48px auto;
  align-items: center;
  grid-row-gap: 4px;
  grid-column-gap: 16px;
}

.ht-notification
  .ant-notification-notice-with-icon
  .ant-notification-notice-icon {
  width: 48px;
  height: 48px;
  grid-row: span 2;
  align-self: center;
}

.ht-notification .ant-notification-notice-message {
  font-weight: bold;
  margin-bottom: 4px;
  @apply text-colorText;
}
.ht-notification .ant-notification-notice-description {
  @apply text-colorTextSecondary;
}

.ht-notification
  .ant-notification-notice-with-icon
  .ant-notification-notice-message {
  grid-column: 2;
  margin: 0;
}
.ht-notification
  .ant-notification-notice-with-icon
  .ant-notification-notice-description {
  grid-column: 2;
  margin: 0;
}
</style>
